import { useNavigate } from 'react-router-dom';

import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { getAppPageConfig } from 'hb-react/frontoffice/utils/page';

const DiscussionNotFound = () => {
  const { configUrls } = useForumContext();
  const navigate = useNavigate();
  const forumTabName = getAppPageConfig('forum')?.menu_name || __('Forum');

  return (
    <SimpleCard
      faIconProps={{
        iconName: 'message-exclamation',
      }}
      title={s__('Forum|Discussion not found')}
      description={s__('Forum|Sorry, this discussion was not found')}
      buttonProps={{
        children: s__('Forum|Go to %{name}').i__({
          name: forumTabName,
        }),
        onClick: () => navigate(configUrls.indexUrl()),
      }}
    />
  );
};

export default DiscussionNotFound;
